import axios from 'axios';

export const waiveInspection = (context, {projectId, inspection}) => {    
    return new Promise((resolve, reject) => {
        inspection.waived = 1;
        axios.patch('/api/projects/' + projectId + '/inspections/' + inspection.id, {
            formConfigurationId: context.state.inspectionFormConfigId,
            entityId: inspection.id,
            data: inspection
        }).then(response => {
            context.commit('updateInspection', response.data);
            resolve(response.data);
        }).catch(error => {
            window.notify.apiError(error);
            reject(error);
        });

    });
}
